export const BookAppointmentStatus = {
  SuccessStatusCode: [0, 21, 22, 23],
  ErrorStatusCode: {
    13: 'Msg_039',
    11: 'Msg_037'
  },
  GeneralMsg: 'Msg_042'
};
